import { z } from 'zod'
import { t } from 'i18next'
import { ZugmeldestelleSchema } from '../../Generic/schema/generic.schema'
import { Betriebsstellenart } from '../../../../types'

// Default constants
const DEFAULT_AUFTRAG21_10 = {
  enabled: true,
  feld21_11: {
    art: '' as '' | Betriebsstellenart,
    name: ''
  }
}

const DEFAULT_AUFTRAG21_12 = {
  enabled: false
}

const DEFAULT_AUFTRAG21_13 = {
  enabled: false
}

const DEFAULT_BEFEHL_21_FORM = {
  auftrag21_10: DEFAULT_AUFTRAG21_10,
  auftrag21_12: DEFAULT_AUFTRAG21_12,
  auftrag21_13: DEFAULT_AUFTRAG21_13
} as const

// Schema definitions
const Auftrag21_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG21_10.enabled),
    feld21_11: ZugmeldestelleSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG21_10))

const Auftrag21_12Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG21_12.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG21_12))

const Auftrag21_13Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG21_13.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG21_13))

// Base schema
const Befehl21FormSchemaBase = z
  .object({
    auftrag21_10: Auftrag21_10Schema,
    auftrag21_12: Auftrag21_12Schema,
    auftrag21_13: Auftrag21_13Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_21_FORM))

export const Befehl21FormSchema = Befehl21FormSchemaBase

// Validation schema factory
export const createBefehl21FormValidationSchema = () => {
  return Befehl21FormSchemaBase.refine(
    (data) => {
      return data.auftrag21_12.enabled !== data.auftrag21_13.enabled
    },
    {
      message: t('ui-validation:befehl21.select_one')
    }
  )
}

export type Befehl21FormData = z.infer<typeof Befehl21FormSchemaBase>
